"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var projectManageApi = _interopRequireWildcard(require("@/api/projectManageApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ProjectDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '项目详情'
    },
    rowData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      drawerSize: '680px',
      loading: false,
      hasLoaded: false,
      projectDetail: {
        id: '',
        projectType: '',
        projectName: '',
        status: '',
        relativeId: '',
        relatedNumber: '',
        cardName: '',
        projectStatus: '',
        totalAmount: '',
        availableAmount: '',
        balanceAmount: '',
        parAmount: '',
        cardCount: 0,
        miniappName: '',
        customerName: '',
        issueTime: '',
        validTime: '',
        createTime: '',
        remark: ''
      },
      projectTypeOptions: [{
        value: 'fixed_meal',
        label: '固定套餐'
      }, {
        value: 'welfare_recharge',
        label: '福卡充值'
      }, {
        value: 'enterprise_recharge',
        label: '企业直充'
      }]
    };
  },
  watch: {
    visible: function visible(val) {
      if (val && this.projectId && !this.loading) {
        this.getProjectDetail();
      }

      // 抽屉关闭时，重置加载状态，确保下次能重新加载
      if (!val) {
        this.hasLoaded = false;
      }
    },
    projectId: function projectId(val) {
      if (val && this.visible && !this.loading) {
        this.getProjectDetail();
      }
    }
  },
  mounted: function mounted() {
    // 移除mounted中的调用，避免重复
  },
  methods: {
    openDetail: function openDetail(projectId, row) {
      // 避免重复调用
      if (this.projectId === projectId && this.visible) {
        return;
      }
      this.projectId = projectId;
      // 保存行数据以备API缺少某些字段时使用
      if (row) {
        this.rowData = row;
      }
      this.visible = true;
      this.getProjectDetail();
    },
    getProjectDetail: function getProjectDetail() {
      var _this = this;
      // 如果正在加载或已经加载过，不再重复调用
      if (this.loading) {
        return;
      }
      if (this.hasLoaded && this.projectId) {
        return;
      }
      this.loading = true;
      this.hasLoaded = false;

      // 只调用一次项目详情接口
      projectManageApi.getFudouProjectDetail(this.projectId).then(function (res) {
        // 格式化数据
        var detail = res;

        // 处理状态，移除所有尾部的点
        var cleanStatus = detail.projectStatus ? detail.projectStatus.replace(/\.+$/, '') : '';
        _this.projectDetail = {
          id: detail.id || _this.rowData.id || '',
          projectType: detail.projectTypeName || _this.rowData.projectType || '',
          projectName: detail.projectName || _this.rowData.projectName || '',
          status: cleanStatus || _this.rowData.status || '',
          relativeId: detail.relativeId || _this.rowData.relatedId || '',
          relatedNumber: detail.relativeId ? "FD".concat(String(detail.relativeId).padStart(6, '0')) : _this.rowData.relatedId ? "FD".concat(String(_this.rowData.relatedId).padStart(6, '0')) : _this.rowData.relatedNumber || '无',
          cardName: detail.cardName || _this.rowData.cardName || '',
          projectStatus: cleanStatus || _this.rowData.status || '',
          totalAmount: _this.formatMoney(detail.totalAmount || _this.rowData.budget),
          availableAmount: _this.formatMoney(detail.balanceAmount || _this.rowData.availableAmount || 0),
          balanceAmount: detail.balanceAmount || _this.rowData.availableAmount,
          parAmount: _this.formatMoney(detail.parAmount || _this.rowData.parAmount || 0),
          cardCount: detail.cardNum || _this.rowData.cardCount || 0,
          miniappName: detail.appName || _this.rowData.miniappName || '',
          customerName: detail.customerName || _this.rowData.customerName || '',
          issueTime: detail.grantTime ? _this.formatDate(detail.grantTime) : _this.rowData.issueTime || '',
          validTime: detail.validTime || _this.rowData.validTime || '',
          createTime: detail.createTime || _this.rowData.createTime || '',
          remark: detail.innerRemark || detail.remark || _this.rowData.remark || ''
        };
        _this.hasLoaded = true;
        _this.loading = false;
      }).catch(function (err) {
        _this.$message.error('获取项目详情失败: ' + (err.message || '未知错误'));
        _this.loading = false;
      });
    },
    // 提供模拟数据用于开发环境
    provideMockData: function provideMockData() {
      var mockStatus = '已完成';
      this.projectDetail = {
        id: this.projectId || 'PRJ004',
        projectType: '固定套餐',
        projectName: '2023年中秋节福利发放',
        status: mockStatus,
        relativeId: 'ORD20230801001',
        relatedNumber: 'FD000044',
        cardName: '中秋节福利卡',
        projectStatus: mockStatus,
        totalAmount: '¥ 30,000',
        availableAmount: '¥ 0',
        cardCount: 100,
        miniappName: '企业福利小程序',
        customerName: '北京慧众百汇科技有限公司',
        issueTime: '2023-09-20 16:30:00',
        validTime: '2023-09-01 至 2023-10-31',
        createTime: '2023-08-25 10:30:00',
        remark: '中秋节员工福利发放，包括月饼、水果和福利卡'
      };
      this.hasLoaded = true;
    },
    // 格式化日期
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';
      var date;
      if (typeof dateStr === 'string') {
        // 尝试解析日期字符串
        date = new Date(dateStr);
      } else if (dateStr instanceof Date) {
        date = dateStr;
      } else {
        return dateStr; // 如果无法解析，返回原值
      }
      if (isNaN(date.getTime())) {
        return dateStr; // 如果日期无效，返回原值
      }
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    // 格式化有效期
    formatValidTime: function formatValidTime(validTime) {
      if (!validTime) return '';

      // 处理特殊格式 "  -  "
      if (validTime.trim() === '-') return '永久有效';

      // 移除多余的空格
      var cleanValidTime = validTime.replace(/\s+/g, ' ').trim();

      // 检查是否有开始和结束日期
      if (cleanValidTime.includes('-')) {
        var _cleanValidTime$split = cleanValidTime.split('-').map(function (d) {
            return d.trim();
          }),
          _cleanValidTime$split2 = _slicedToArray(_cleanValidTime$split, 2),
          start = _cleanValidTime$split2[0],
          end = _cleanValidTime$split2[1];
        if (!start && !end) return '永久有效';
        if (!start) return "\u622A\u81F3 ".concat(end);
        if (!end) return "".concat(start, " \u8D77");
        return "".concat(start, " \u81F3 ").concat(end);
      }
      return validTime;
    },
    viewCardDetail: function viewCardDetail() {
      this.$router.push({
        path: '/welfare/card/detail',
        query: {
          projectId: this.projectId
        }
      });
    },
    getTagType: function getTagType(status) {
      // 先判断是否为空
      if (!status) return 'info';

      // 特殊处理"已生成订单"状态
      if (status.includes('已生成订单')) {
        return 'primary';
      }

      // 先清理状态值中可能存在的点
      var cleanStatus = status.replace(/\.+$/, '');
      var statusMap = {
        // 英文状态映射
        'pending': 'warning',
        'in_progress': 'primary',
        'processing': 'primary',
        'completed': 'success',
        'cancelled': 'danger',
        'created': 'info',
        'active': 'success',
        'inactive': 'info',
        // 中文状态映射
        '已删除': 'danger',
        '卡密生成中': 'info',
        '作废': 'danger',
        '已下单': 'primary',
        '已确认': 'warning',
        '已生成订单': 'primary',
        '待发放': 'warning',
        '已发放': 'success',
        '生成中': 'info',
        '处理中': 'primary',
        '已取消': 'danger',
        '已拒绝': 'danger',
        '已过期': 'info',
        '已失效': 'info',
        '待审核': 'warning',
        '审核通过': 'success',
        '审核未通过': 'danger'
      };
      return statusMap[cleanStatus] || 'info';
    },
    getStatusName: function getStatusName(status) {
      // 如果状态为空则返回空
      if (!status) return '';

      // 对特定状态进行特殊处理
      if (status.includes('已生成订单')) {
        return '已生成订单';
      }

      // 先移除尾部的点，再映射状态
      var cleanStatus = status.replace(/\.+$/, '');
      var statusMap = {
        'pending': '待开始',
        'in_progress': '进行中',
        'processing': '处理中',
        'completed': '已完成',
        'cancelled': '已取消',
        'created': '已创建',
        'active': '活跃',
        'inactive': '非活跃'
      };
      return statusMap[cleanStatus] || cleanStatus;
    },
    formatMoney: function formatMoney(amount) {
      if (!amount && amount !== 0) return '¥0';
      if (typeof amount === 'string') {
        // 移除非数字字符(除了小数点)
        var value = amount.replace(/[^\d.]/g, '');
        return '¥ ' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else if (typeof amount === 'number') {
        return '¥ ' + amount.toLocaleString();
      }
      return '¥ ' + amount;
    }
  }
};